import { useFormikContext } from 'formik'

import { REQUEST_STATUS } from '../../../../constants/request'
import Button from '../../../Button'
import { EntityStatus } from '../../../Entity'
import { REQUEST_EDIT_STATUS_FIELD_NAME } from '../RequestEditStatusModal.constants'

function RequestEditStatusModalSelectButton({
  afterIconProps,
  className,
  disabled,
  elementRef,
  error,
  height,
  isOpen,
  isSkeleton,
  qaName,
  showTextTooltip,
  text,
  tooltip,
  onClick,
}) {
  const { values } = useFormikContext()

  const status = values[REQUEST_EDIT_STATUS_FIELD_NAME]

  return (
    <Button.Select
      afterIconProps={afterIconProps}
      className={className}
      disabled={disabled}
      elementRef={elementRef}
      error={error}
      height={height}
      isActive={isOpen}
      isSkeleton={isSkeleton}
      qaName={qaName}
      showTextTooltip={showTextTooltip}
      text={status?.id ? null : text}
      tooltip={tooltip}
      onClick={onClick}
    >
      {status?.id ? (
        <EntityStatus id={status.id} statuses={REQUEST_STATUS} />
      ) : null}
    </Button.Select>
  )
}

export default RequestEditStatusModalSelectButton
